import React from 'react';

interface OnboardingProgressProps {
  currentStep: number;
  totalSteps: number;
}

export function OnboardingProgress({ currentStep, totalSteps }: OnboardingProgressProps) {
  return (
    <div className="flex items-center gap-2">
      {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
        <div
          key={step}
          className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
            step === currentStep
              ? 'bg-[#FF6B35]'
              : step < currentStep
              ? 'bg-gray-400'
              : 'bg-transparent border-2 border-gray-300'
          }`}
        />
      ))}
    </div>
  );
}
